import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-[#0D0D0D] text-white py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-83">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#F5C518] opacity-5 rounded-full blur-[80px]" data-id="element-84"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#22C55E] opacity-5 rounded-full blur-[80px]" data-id="element-85"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-86">
        <div className="inline-flex items-center justify-center p-3 bg-[#F5C518]/10 rounded-2xl mb-8" data-id="element-87">
          <SparklesIcon className="w-8 h-8 text-[#F5C518]" data-id="element-88" />
        </div>

        <h2 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight" data-id="element-89">
          EL SECRETO: <br data-id="element-90" />
          <span className="text-[#F5C518]" data-id="element-91">
            EL SISTEMA DE SUSTITUCIÓN CRIOLLA
          </span>
        </h2>

        <p className="font-inter text-xl md:text-2xl text-gray-300 leading-relaxed mb-8 max-w-3xl mx-auto" data-id="element-92">
          Es un método donde{' '}
          <strong className="text-white" data-id="element-93">
            no sacrificas el chicharrón, ni el queso, ni el aguacate, ni el
            sabor.
          </strong>
        </p>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-sm" data-id="element-94">
          <p className="font-inter text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-95">
            Aprendes a identificar exactamente qué comprar en los supermercados
            locales de bajo costo para entrar en cetosis (quema de grasa) de
            forma automática. Es Keto aplicado a la vida real en Colombia:{' '}
            <span className="text-[#F5C518] font-bold" data-id="element-96">
              práctico, barato y delicioso.
            </span>
          </p>
        </div>
      </div>
    </section>;
}